<div *ngIf="!isComplete" class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  Please wait we are processing your order...
</div>
<div style="text-align: center; margin: 30px;" *ngIf="isComplete && !isError">
  <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
        style="font-size:50px;color:green"></span>
  <p>{{lblText.submitedInfo1?lblText.submitedInfo1:checkOut.submitedInfo1}}</p>
  <h4>{{lblText.submitedInfo2?lblText.submitedInfo2:checkOut.submitedInfo2}}</h4>
  <p>
    {{lblText.kawneerOrderLbl?lblText.kawneerOrderLbl:checkOut.kawneerOrderLbl}}:  #{{lblText.kdLbl?lblText.kdLbl:checkOut.kdLbl}}{{acknowledgeNumber}}.
  </p>
  <p>
    <button kendoButton primary="true" style="width: 300px;" [routerLink]="['/home']">{{lblText.continueShoppingLbl?lblText.continueShoppingLbl:checkOut.continueShoppingLbl}}</button>
  </p>
  <div>
    <a style=" cursor:pointer;" [routerLink]="['/survey']">
      {{lblText.surveyFeedbackLbl?lblText.surveyFeedbackLbl:checkOut.surveyFeedbackLbl}}
    </a>
  </div>
</div>
<div style="text-align: center; margin: 30px;" *ngIf="isComplete && isError">
  <span class="k-icon k-i-close-outline k-i-x-outline k-i-error"
        style="font-size:50px;color:red"></span>
  <h4>{{lblText.submitedInfo3?lblText.submitedInfo3:checkOut.submitedInfo3}}</h4>
  <p>{{lblText.submitedInfo4?lblText.submitedInfo4:checkOut.submitedInfo4}}</p>
  <p>
    <!--What happens if we encounter error at this stage???-->
    <button kendoButton primary="true" style="width: 300px;" [routerLink]="['/home']">Retry</button>
  </p>
</div>
